import { useCallback, useEffect, useState } from "react";
import notificationSound from "../audio/notification_clock_alarm.mp3";

export const useNotification = () => {
  const sound = new Audio(notificationSound);
  const [isUnlocked, setUnlocked] = useState(false);

  useEffect(() => {
    const unlock = () => {
      sound?.play().then(() => {
        sound?.pause();
        sound!.currentTime = 0;
        setUnlocked(true);
        window.removeEventListener("click", unlock);
      });
    };
    window.addEventListener("click", unlock, { once: true });
    return () => window.removeEventListener("click", unlock);
  }, []);

  const play = useCallback(() => {
    sound.currentTime = 0;
    sound.volume = 1;
    sound.play().catch(() => {
      console.warn(notificationSound);
    });
  }, [isUnlocked]);

  return { play };
};
